module.exports = __webpack_public_path__ + "static/speech-bubbles-1cba43a551614d25096e9699a95ef6fd.gif";